'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["colorSet", "className"];
import React from 'react';
import { spacer8, spacer12 } from '@spotify-internal/encore-foundation';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { addColorSet, cssSpacing, defaultColorSet, overlay, rootStyle, viola } from "../../styles/index.mjs";
import { StatefulTooltip } from "./StatefulTooltip.mjs";
import styled from "../../styled-components.mjs";
export var TooltipWrapper = styled.div.withConfig({
  displayName: "Tooltip__TooltipWrapper",
  componentId: "sc-muq3yw-0"
})(["", ";", ";", ";padding-block-start:", ";padding-block-end:", ";padding-inline-start:", ";padding-inline-end:", ";text-transform:initial;color:var(--text-base,", ");overflow-wrap:break-word;"], rootStyle(), overlay({
  maxWidth: '240px'
}), viola(), cssSpacing('tighter-2', spacer8), cssSpacing('tighter-2', spacer8), cssSpacing('tighter', spacer12), cssSpacing('tighter', spacer12), defaultColorSet.text.base);

/**
* **Tooltip** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Tooltip) | [Figma](https://www.figma.com/file/bnQXqGkLeiTlbk8JXGDcsX/Encore-Web---Light-Theme-Toolkit?node-id=0:1543)
*
* The Tooltip displays a text label when users hover over or focus on an element.
*
* [Read the full component documentation →](https://encore.spotify.net/web/components/tooltip)
*
* @example
* () => (
*  <Tooltip>Aenean lacinia bibendum nulla sed consectetur. Cras justo.</Tooltip>
*);
*
*/
export var Tooltip = /*#__PURE__*/React.forwardRef(function Tooltip(_ref, ref) {
  var _ref$colorSet = _ref.colorSet,
    colorSet = _ref$colorSet === void 0 ? 'base' : _ref$colorSet,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return props.trigger ? /*#__PURE__*/React.createElement(StatefulTooltip, Object.assign({
    ref: ref,
    className: addColorSet(colorSet, className),
    role: "tooltip",
    "data-encore-id": ENCORE_DATA_IDS.Tooltip
  }, props)) : /*#__PURE__*/React.createElement(TooltipWrapper, Object.assign({
    ref: ref,
    className: addColorSet(colorSet, className),
    role: "tooltip",
    "data-encore-id": ENCORE_DATA_IDS.Tooltip
  }, props));
});